import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { yearinfoService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as yearinfoActions from './actions';
import * as _ from "lodash";

export function fetchYearInfo(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_YEAR_INFO),
    mergeMap(({ payload }) => {
      return yearinfoService.getYearInfo(payload)
        .pipe(
          map(res => yearinfoActions.fetchYearInfoSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}